"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _react = require("@emotion/react");

var _util = require("../../util");

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var base = function base(theme) {
  return /*#__PURE__*/(0, _react.css)("flex-shrink:0;background-color:", theme.color.monochrome.white, ";position:sticky;top:0;z-index:999;padding-top:", (0, _util.rem)(13), ";min-height:", (0, _util.rem)(54), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:base;"));
};

var compact = /*#__PURE__*/(0, _react.css)("padding-left:0!important;padding-right:0!important;margin:0 -", (0, _util.rem)(24), " 0 -", (0, _util.rem)(24), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:compact;"));
var offsetInkbar = process.env.NODE_ENV === "production" ? {
  name: "edg9ku",
  styles: "margin-bottom:-2px"
} : {
  name: "1f0eohr-offsetInkbar",
  styles: "margin-bottom:-2px;label:offsetInkbar;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var wrapper = /*#__PURE__*/(0, _react.css)("margin-right:", (0, _util.rem)(-8), ";button{margin-right:", (0, _util.rem)(8), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:wrapper;"));

var _ref = process.env.NODE_ENV === "production" ? {
  name: "1duj7gx",
  styles: "align-self:flex-end"
} : {
  name: "ayhscl-bigTab",
  styles: "align-self:flex-end;label:bigTab;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var bigTab = function bigTab() {
  return _ref;
};

var smallTab = process.env.NODE_ENV === "production" ? {
  name: "qbt5ty",
  styles: "align-self:center"
} : {
  name: "1hddj7n-smallTab",
  styles: "align-self:center;label:smallTab;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var styles = {
  base: base,
  compact: compact,
  offsetInkbar: offsetInkbar,
  bigTab: bigTab,
  smallTab: smallTab,
  wrapper: wrapper
};
exports.styles = styles;
//# sourceMappingURL=Header.styles.js.map